query PaymentsInvoicesSigningSearch(
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $first: Int
  $after: Cursor
  $orderBy: [InvoicesOrderBy!]
  $filter: InvoiceFilter
  $invoiceSigningSearchSearchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $isSearchAllData: Boolean
) {
  invoiceSigningSearch(
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
    searchRequest: $invoiceSigningSearchSearchRequest
    isLinkSearch: $isLinkSearch
    isSearchAllData: $isSearchAllData
  ) {
    nodes {
      id
      transactionType {
        transactionType
        layoutType
        isDocumentSigningPayment
      }
      vendorReference
      description
      invoiceNumber
      invoiceDate
      _pendingApprovers
      _createdByUserName
      companyCorporatePeriod {
        _periodYear
      }
      department {
        name
      }
      businessUnit {
        name
      }
      controlTotalAmount
      currency {
        isoCode
        name
      }
      _baseCurrencyAmount
      _spotCurrencyAmount
      company {
        name
      }
      invoiceHistoryApprover {
        requesterName
        requesterDate
        approvers
        approvedDate
        rejectors
        rejectedDate
        amendedByName
        amendedDate
      }
      statusType {
        statusType
        approvalState
        isDraftReleaseRequired
        _transactionIconStatus
      }
      companyTransactionType {
        exportLayout
      }
      _accountingStampDate
      _accountingStampUserName
      _accountingStampTransactionReference
      currencyId
      _isApprovalDocumentsRequired
      _isStagedApprovalRequest
      _isTransactionCancelled
      _isAccountingEntry
      _isAccountingEntryStampedComplete
      reimburseAmount
      corporatePeriodId
      _isDeletable
      _rowTimestamp
      _createdDate
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
